const actions = {
  GET_USER_ORGANIZATIONS_REQUEST: "GET_USER_ORGANIZATIONS_REQUEST",
  GET_USER_ORGANIZATIONS_SUCCESS: "GET_USER_ORGANIZATIONS_SUCCESS",

  GET_RESTAURANTS_REQUEST: "GET_RESTAURANTS_REQUEST",
  GET_RESTAURANTS_SUCCESS: "GET_RESTAURANTS_SUCCESS",

  COLLPSE_CHANGE: "COLLPSE_CHANGE",
  COLLPSE_OPEN_DRAWER: "COLLPSE_OPEN_DRAWER",
  CHANGE_OPEN_KEYS: "CHANGE_OPEN_KEYS",
  TOGGLE_ALL: "TOGGLE_ALL",
  CHANGE_CURRENT: "CHANGE_CURRENT",
  CLEAR_MENU: "CLEAR_MENU",

  SET_SELECTED_RESTAURANT: "SET_SELECTED_RESTAURANT",

  setSelectedRestaurant: (restaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_SELECTED_RESTAURANT,
        restaurant,
      });
    };
  },
  getRestaurants: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_RESTAURANTS_REQUEST,
      });
    };
  },
  getOrganizations: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_USER_ORGANIZATIONS_REQUEST,
      });
    };
  },
};
export default actions;
